/**
 * FurnitureItemSelectionPopup — native furniture-template picker (lifted from
 * `common/StagingFlow/RoomItems/FurnitureTemplateSelectionPopup.component.tsx`,
 * rewired onto the module working context + `patchRoom` + plain-JS
 * `styleCodeMap` pair array). Reuses the generic `StagingItemSelectionPopup`
 * (context-free, `components/common/*`). Analytics dropped (DF-staging-analytics).
 */

import { FC } from 'react'

import { StagingItemSelectionPopup } from 'components/common/StagingFlow/StagingItemSelectionPopup'
import { VirtualFurnitureRoomType, VirtualFurnitureStyleCategory } from 'constants/virtualFurniture'
import { useTranslation } from 'react-i18next'

import { useStagingWorkingState } from '../StagingWorkingState.context'
import { useStagingStylesFilter } from '../useStagingStylesFilter'

export const FurnitureItemSelectionPopup: FC<{ isOpen: boolean }> = ({ isOpen }) => {
  const { t } = useTranslation(['style_selection_order_step', 'virtual_furniture_room_type'])
  const { activeRoom, setRoomItemPopupType, patchRoom } = useStagingWorkingState()
  const { filteredStylesByRoomType, availableFiltersByRoomType } = useStagingStylesFilter()

  if (!activeRoom) return null

  return (
    <StagingItemSelectionPopup
      availableItems={filteredStylesByRoomType}
      title={t('style_selection_order_step:room_items.FURNITURE')}
      isOpen={isOpen}
      selectedItems={Object.fromEntries(activeRoom.styleCodeMap)}
      filters={availableFiltersByRoomType}
      activeFilter={activeRoom.styleCategory}
      tabTranslationResolver={(tab) => t(`virtual_furniture_room_type:${tab}`)}
      onClose={() => {
        setRoomItemPopupType(null)
        patchRoom(activeRoom.key, { styleCategory: null })
      }}
      onFilterUpdate={(style) => {
        patchRoom(activeRoom.key, { styleCategory: style as VirtualFurnitureStyleCategory })
      }}
      onSelect={(selectedStyles) => {
        patchRoom(activeRoom.key, {
          styleCodeMap: Object.entries(selectedStyles) as Array<[VirtualFurnitureRoomType, string]>,
        })
        setRoomItemPopupType(null)
      }}
    />
  )
}
